import styles from "./ConfirmarPedido.module.scss";
import { textoVariacoes } from "shared/utils/carrinho";
import PageContainer from "shared/components/pagecontainer/PageContainer";
import { useNavigate, useLocation } from "react-router-dom";
import { useContext, useMemo } from "react";
import { CartContext } from "shared/contexts/Cart/CartContext";
import { formatarMoeda,} from "shared/utils/money";
import { CircleCheckBig, ShoppingBag, ShoppingCart} from "lucide-react";

export const ConfirmarPedido = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { cart} =
    useContext(CartContext);

  const frete = location.state?.frete ?? 0;

  /* ================= SUBTOTAL ================= */
  const subtotal = useMemo(() => {
    return cart.reduce((acc, item) => {
      return acc + item.preco * item.unidades;
    }, 0);
  }, [cart]);

  const totalFinal = subtotal + frete;

  const handleConfirmar = () => {
    navigate("/carrinho/finalizar", {
      state: { frete },
    });
  };

  const handleCancelar = () => {
    navigate("/carrinho");
  };

  return (
    <PageContainer title="Confirmando Pedido" icon={<ShoppingCart />}>
      <div className={styles.page}>
        <div className={styles.card}>

          {/* ÍCONE */}
          <CircleCheckBig className={styles.iconSucesso} size={30} />

          <h3 className={styles.title}>Confirma sua compra?</h3>

          {/* RESUMO */}
          <div className={styles.containerResumo}>
            <div className={styles.headerResumo}>
              <div className={styles.containerTitulo}>
                <ShoppingBag size={16} color="var(--secondary-2)" />
                <p className={styles.tituloResumo}>Resumo do Pedido</p>
              </div>
            </div>

            {cart.map(item => (
              <div key={item.id} className={styles.produto}>
                <img
                  src={item.gallery || "/imagens/default.png"}
                  alt="imagem"
                />

                <div className={styles.info}>
                  <p className={styles.nome}>{item.name}</p>
                  {textoVariacoes(item) && (
                    <p className={styles.variacoes}>{textoVariacoes(item)}</p>
                  )}
                  <p className={styles.preco}>
                    {formatarMoeda(item.preco)}
                  </p>
                </div>
              </div>
            ))}

            {/* SUBTOTAL + FRETE */}
            <div className={styles.containerSubtotal}>
              <div className={styles.linha}>
                <p>Subtotal:</p>
                <p>{formatarMoeda(subtotal)}</p>
              </div>

              <div className={styles.linha}>
                <p>Frete:</p>
                <p className={frete === 0 ? styles.calculado : ""}>
                  {frete === 0 ? "Será Calculado" : formatarMoeda(frete)}
                </p>
              </div>
            </div>

            {/* TOTAL */}
            <div className={styles.total}>
              <p>Total:</p>
              <p>{formatarMoeda(totalFinal)}</p>
            </div>
          </div>

          {/* BOTÕES */}
          <div className={styles.actions}>
            <button className={styles.cancelar} onClick={handleCancelar}>
              Cancelar
            </button>

            <button className={styles.confirmar} onClick={handleConfirmar}>
              Confirmar
            </button>
          </div>

        </div>
      </div>
    </PageContainer>
  );
};